module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/418.58fe73a7.png";